import axios from "axios";
import config from "../config";
import { authenticationToken } from "./useAuth";

axios.interceptors.request.use(async (config) => {
  if (config.url.includes("/api/auth/")) return config;
  if (
    config.headers.Authorization !== undefined &&
    config.headers.Authorization !== null
  ) {
    return config;
  }

  const authToken = authenticationToken();
  if (authToken === null) {
    window.location.reload();
  }

  config.headers.Authorization = `Bearer ${authToken}`;
  return config;
});

const apiGet = async (url, token) => {
  return axios.get(`${config.API_URL}${url}`, {
    headers: { "X-API-KEY": token },
  });
};

const apiDelete = async (url, token) => {
  return axios.delete(`${config.API_URL}${url}`, {
    headers: { "X-API-KEY": token },
  });
};

const apiPost = async (url, form, token) => {
  return axios.post(`${config.API_URL}${url}`, form, {
    headers: { "X-API-KEY": token },
  });
};

const apiPut = async (url, bankData, token) => {
  const data = bankData;
  return axios.put(`${config.API_URL}${url}`, data, {
    headers: { "X-API-KEY": token },
  });
};


export const apiGetBankDetailFromIBAN = async (iban, token) => {
  return apiGet(`iban/${iban}`, token);
};

export const apiValidateABARoutingNumber = async (abaRoutingNumber, token) =>{
  return apiGet(`aba/${abaRoutingNumber}`, token);
}

export const apiGetBankDetailFromBIC = async (accountNr, bic, token) => {
  return apiGet(`bic?bic=${bic}&accountNr=${accountNr}`, token);
};

export const apiGetRequest = async (token) => {
  return apiGet("employee", token);
};

export const apiPostBankDetail = async (bankData, token) => {
  return apiPost("bankdata", bankData, token);
};

export const apiSaveEmployeeInformation = async (employeedata, token) => {
  return apiPost("employee/SaveEmployeeInformation", employeedata, token);
};

export const apiPutBankDetail = async (id, bankData, token) => {
  return apiPut(`bankdata/${id}`, bankData, token);
};

export const apiDeleteBankDetail = async (token, id) => {
  return apiDelete(`bankdata/${token}/${id}`, token);
};

export const apiDeleteFile = async (token, fileName) => {
  return apiDelete(`files/${fileName}`, token);
};

export const apiPostFiles = async (form, token) => {
  return apiPost("files", form, token);
};

export const apiUpdateEmployee = async (employeeId, token) => {
  return apiPost("employee", employeeId, token);
};

export const apiUpdateGiro = async (isGiro, token) => {
  return apiGet(`employee/banktype?isGiro=${isGiro}`, token);
};

export const apiSubmitRequest = async (token) => {
  return apiGet("employee/complete", token);
};


export const apiGetCalculatedIBAN = async (bankCode, accountNumber, token, countryCode = "DK") => {
  return apiGet(`iban/calculate?bankCode=${bankCode}&accountNumber=${accountNumber}&countryCode=${countryCode}`, token);
};

export const apiSearchBanks = async (searchType, searchTerm, token) => {
  // Build query string based on search type
  let queryString = '';
  
  if (searchType && searchTerm) {
    queryString = `${searchType}=${encodeURIComponent(searchTerm)}`;
  }
  
  return apiGet(queryString ? `bankdata/GetBanksFromMyHR?${queryString}` : `bankdata/GetBanksFromMyHR`, token);
};

export const apiBankDataSetPrimary = async (bankDataId, token) => {
  return apiGet(`bankdata/setprimary/${bankDataId}`, token);
};

export const apiGetAuthTypes = async (token) => {
  return apiGet("auth/auth-types", token);
};

export const apiSendAuthCode = async (data, token) => {
  return apiPost("auth/SendCode", data, token);
};

export const apiAuthenticate = async (key, code, channel) => {
  return apiPost(
    "auth/authenticate",
    {
      key: key,
      code: code,
      channel: channel,
    },
    key
  );
};
